import React from 'react';
import { Link } from 'react-router-dom';
import '../../App.css';

function Layout({ children }) {
  return (
    <div className="layout">
        {/* Navigation */}
        <nav className="navbar">
        <div className="container">
            <div className="logo"><Link to="/" className="nav-link"><span className="logo-box">Aamb</span></Link></div>
            <div className="nav-links">
                <Link to="/about" className="nav-link">About Us</Link> {/* Link to capability page */}
            </div>
            </div>
        </nav>

        {/* Page content goes here */}
        <div className="page-content">
            {children}
        </div>

        {/* Footer Section */}
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                <div className="footer-brand">
                    <p className="copyright">© {new Date().getFullYear()} AAMB LLC. All rights reserved.</p>
                </div>
                </div>
            </div>
        </footer>
    </div>
  );
}

export default Layout;